import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import PageBackdrop from './PageBackdrop';

const HeroSection = styled.section`
  padding: calc(var(--nav-height) + 40px) 0 72px;
  text-align: center;
  position: relative;
  overflow: hidden;
  background: #fff;
`;

const Content = styled.div`
  position: relative;
  z-index: 2;
  max-width: 720px;
  margin: 0 auto;
`;

const Breadcrumbs = styled(motion.nav)`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 20px;
  font-size: 0.82rem;

  a {
    color: #94a3b8;
    text-decoration: none;
    &:hover { color: #0e6b3c; }
  }

  span.sep { color: #cbd5e1; }
  span.current { color: #0e6b3c; font-weight: 600; }
`;

const Label = styled(motion.span)`
  display: block;
  font-family: var(--font-display);
  font-size: 0.78rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.16em;
  color: #0e6b3c;
  margin-bottom: 14px;
`;

const Title = styled(motion.h1)`
  font-family: var(--font-display);
  font-size: clamp(2.2rem, 5vw, 3.25rem);
  font-weight: 800;
  margin-bottom: 16px;
  color: #07111f;
  letter-spacing: -0.03em;
  line-height: 1.12;

  .highlight {
    color: #0e6b3c;
  }
`;

const Description = styled(motion.p)`
  font-size: clamp(1rem, 2vw, 1.1rem);
  color: #64748b;
  line-height: 1.75;
  max-width: 560px;
  margin: 0 auto;
`;

function renderTitle(title, titleHighlight) {
  if (!titleHighlight || !title.includes(titleHighlight)) return title;
  const parts = title.split(titleHighlight);
  return (
    <>
      {parts[0]}
      <span className="highlight">{titleHighlight}</span>
      {parts[1]}
    </>
  );
}

const PageHero = ({ label, title, titleHighlight, description, breadcrumb }) => (
  <HeroSection>
    <PageBackdrop variant="hero" />
    <div className="container">
      <Content>
        {breadcrumb && (
          <Breadcrumbs initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }}>
            <Link to="/">Home</Link>
            <span className="sep">/</span>
            <span className="current">{breadcrumb}</span>
          </Breadcrumbs>
        )}
        {label && (
          <Label initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }}>
            {label}
          </Label>
        )}
        <Title initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.05 }}>
          {renderTitle(title, titleHighlight)}
        </Title>
        {description && (
          <Description initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.1 }}>
            {description}
          </Description>
        )}
      </Content>
    </div>
  </HeroSection>
);

export default PageHero;
